import { render, staticRenderFns } from "./CartWorld.vue?vue&type=template&id=db64f27a&scoped=true"
import script from "./CartWorld.vue?vue&type=script&lang=js"
export * from "./CartWorld.vue?vue&type=script&lang=js"
import style0 from "./CartWorld.vue?vue&type=style&index=0&id=db64f27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db64f27a",
  null
  
)

export default component.exports